<div class="client-page-content">

  <div class="resume" *ngIf="booking && !booking.paid">

    <app-client-confirm
      *ngIf="currentPage === 0"
      [merchant]="merchant"
      [store]="booking.store"
      [services]="[booking.service]"
      [providers]="[booking.provider]"
      [inputBooking]="booking"
      [day]="day"
      [time]="time"
      [payOnlyPage]="true"
      (saved)="finalBooking = $event; currentPage = currentPage + 1"
      >
    </app-client-confirm>

    <app-client-success
      *ngIf="currentPage === 1"
      [store]="booking.store"
      [booking]="finalBooking"
      [payOnlyPage]="true"
      >
    </app-client-success>

  </div>

  <div class="resume" *ngIf="booking && booking.paid">
    <p class="text-center">
      {{ 'CLIENT.clientPayBooking.alreadyPaid' | translate }}
    </p>
  </div>

  <app-alert type="danger" [msg]="errorMsg"></app-alert>
</div>
